import React, { useState, useEffect } from "react"
import { Row, Col, CardBody, Card, Container, Form, Label, Input, Button, Spinner } from "reactstrap"
import { useNavigate, useParams, Link } from "react-router-dom"
import axios from "axios"
import profileImg from "../../assets/images/profile-img.png"
import logoImg from "../../assets/images/logo.svg"

const SubUserRegistration = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [invitedEmail, setInvitedEmail] = useState("");
  const [statusMsg, setStatusMsg] = useState("");
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidating, setIsValidating] = useState(true);
  const [isExistingUser, setIsExistingUser] = useState(false);
  const [existingUserName, setExistingUserName] = useState("");

  const { inviteId, token } = useParams();
  const navigate = useNavigate();

  let baseUrl = process.env.REACT_APP_STATUS === "PROD" ? process.env.REACT_APP_PROD_URL : (process.env.REACT_APP_STATUS === "STAGE" ? process.env.REACT_APP_STAGE_URL : process.env.REACT_APP_DEV_URL);

  useEffect(() => {
    const validateInvite = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/v1/companyAuth/check-invite/${inviteId}/${token}`);
        if (response.data.valid) {
          setIsExistingUser(response.data.isExistingUser);
          setExistingUserName(response.data.existingUserName);
          setInvitedEmail(response.data.email);
        }
      } catch (err) {
        setIsError(true);
        setStatusMsg(err.response?.data?.msg || "Invalid or expired invite.");
      } finally {
        setIsValidating(false);
      }
    };
    validateInvite();
  }, [inviteId, token, baseUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isExistingUser) {
      if (email !== invitedEmail) {
        setIsError(true);
        setStatusMsg("Please enter the email address the invite was sent to.");
        return;
      }
      if (!password) {
        setIsError(true);
        setStatusMsg("Please enter your password to accept the assigned devices.");
        return;
      }
    } else {
      if (password !== confirmPassword) {
        setIsError(true);
        setStatusMsg("Passwords do not match!");
        return;
      }
    }

    setIsLoading(true);
    setStatusMsg("");
    try {
      const payload = isExistingUser ? { password } : { name, password };
      const response = await axios.post(`${baseUrl}/api/v1/companyAuth/register-subuser/${inviteId}/${token}`, payload);
      setIsError(false);
      setStatusMsg(response.data.msg || "Registration successful! Redirecting...");

      localStorage.setItem("token", response.data.token)
      setTimeout(() => {
        navigate("/company-login");
      }, 2000);

    } catch (err) {
      setIsError(true);
      setStatusMsg(err.response?.data?.msg || "Registration failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (isValidating) {
    return (
      <div className="account-pages my-5 pt-sm-5 text-center">
        <Spinner color="primary" />
        <p className="mt-3">Validating invite...</p>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {isExistingUser ? "Accept Device Assignment" : "Complete Registration"}
                        </h5>
                        <p>
                          {isExistingUser ? `Welcome back, ${existingUserName}! Click below to accept the new devices.` : "Sign up to view your assigned devices."}
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img src={logoImg} alt="" className="rounded-circle" height="34" />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form className="form-horizontal" onSubmit={handleSubmit}>
                      {statusMsg && (
                        <div className={`alert ${isError ? 'alert-danger' : 'alert-success'} text-center mb-4`} role="alert">
                          {statusMsg}
                        </div>
                      )}

                      {!isExistingUser && !isError && (
                        <>
                          <div className="mb-3">
                            <Label className="form-label">Full Name</Label>
                            <Input
                              name="name"
                              className="form-control"
                              placeholder="Enter your full name"
                              type="text"
                              required
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Password</Label>
                            <Input
                              name="password"
                              className="form-control"
                              placeholder="Enter password"
                              type="password"
                              required
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Confirm Password</Label>
                            <Input
                              name="confirmPassword"
                              className="form-control"
                              placeholder="Confirm password"
                              type="password"
                              required
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                          </div>
                        </>
                      )}

                      {isExistingUser && !isError && (
                        <>
                          <div className="mb-3">
                            <Label className="form-label">Email</Label>
                            <Input
                              name="email"
                              className="form-control"
                              placeholder="Enter your email"
                              type="email"
                              required
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <div className="mb-3">
                            <Label className="form-label">Password</Label>
                            <Input
                              name="password"
                              className="form-control"
                              placeholder="Enter password"
                              type="password"
                              required
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>
                        </>
                      )}

                      {!isError && (
                        <div className="mt-4 d-grid">
                          <Button color="primary" type="submit" disabled={isLoading}>
                            {isLoading ? "Processing..." : (isExistingUser ? "Accept Assigned Devices" : "Register")}
                          </Button>
                        </div>
                      )}

                      {!isExistingUser && !isError && (
                        <div className="mt-4 text-center">
                          <p className="mb-0">Already have an account? <Link to="/company-login" className="text-primary fw-semi-bold">Login</Link></p>
                        </div>
                      )}

                      {isError && (
                        <div className="mt-4 text-center">
                          <p className="mb-0">Go back to <Link to="/company-login" className="text-primary fw-semi-bold">Login</Link></p>
                        </div>
                      )}

                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SubUserRegistration
